import { connect } from 'react-redux';
import get from 'lodash/get';
import InstrumentTableComponent from './InstrumentTableComponent';
import { selectedInstrumentSelector } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';

const mapStateToProps = state => {
  const selectedInstrument = selectedInstrumentSelector(state);

  const { level1 } = state.apexCore ? state.apexCore : {};
  const selectedInstrumentId = get(selectedInstrument, 'InstrumentId', '');

  return {
    level1: level1[selectedInstrumentId],
    selectedInstrument
  };
};

export default connect(
  mapStateToProps,
  null
)(InstrumentTableComponent);
